module.exports = __webpack_public_path__ + "static/img/9c.2ba628f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9c.jpg
// module id = cf5/
// module chunks = 0